import * as actions from '../actions/legalNatureActionTypes';


const initialState = {
  legalNatureList: {
    success: false,
    errors: null,
    warnings: null,
    legalNatures: [   
      {
        legalNatureKey: 0,
        languageData: [
          {
            language: "deu",
            name: "...",
            code: ""
          },
          {
            language: "ita",
            name: "...",
            code: ""
          },
          {
            language: "eng",
            name: "...",
            code: ""
          }
        ] 
      }
    ]  
  }
}


function legalNature(state = initialState, action) {  
  switch (action.type) {
    case actions.LEGAL_NATURE_LIST_LOAD:
      return {
        ...state, 
        legalNatureList: action.legalNatureList
      }    
    default:        
      return state
  } 
}


export default legalNature
